import React from "react";

export default function SampleLink({ sample, disabled = false }) {
  return disabled ? (
    sample.identifier
  ) : (
    <a
      onClick={e => e.stopPropagation()}
      href={"/laboratory/samples/" + sample.identifier}
      target="_blank"
    >
      {sample.identifier}
    </a>
  );
}
